// extracted by mini-css-extract-plugin
export default {"spinnerMask":"SpinnerMark_spinnerMask__fEc2F"};